/**
 * DOM id the plan card carries at its anchor row — a transcript can hold more
 * than one plan card, so the summary can't select on the testid.
 */
export const planAnchorElementId = (anchorId: string): string =>
  `plan-anchor-${anchorId}`;

/**
 * Scoped to the scroller: an IntersectionObserver target outside its root
 * reports "not intersecting" forever, pinning the summary open.
 */
export const findPlanAnchorElement = (
  scroller: HTMLElement | null,
  anchorId: string
): HTMLElement | null => {
  const anchor = scroller?.ownerDocument.getElementById(planAnchorElementId(anchorId));
  return anchor && scroller?.contains(anchor) ? anchor : null;
};

export const PLAN_ANCHOR_SENTINEL_ATTRIBUTE = 'data-plan-anchor-sentinel';

/**
 * The node the summary observes: a hairline sentinel at the card's top edge,
 * so the summary appears the moment the card starts to scroll off — observing
 * the card itself would wait until the whole card is gone.
 */
export const findPlanAnchorObservationTarget = (
  scroller: HTMLElement | null,
  anchorId: string
): HTMLElement | null => {
  const anchor = findPlanAnchorElement(scroller, anchorId);
  return (
    anchor?.querySelector<HTMLElement>(`[${PLAN_ANCHOR_SENTINEL_ATTRIBUTE}]`) ?? anchor
  );
};
